export default __webpack_public_path__ + "static/media/vaccination-card.75378e39.png";